export default {
    companyDetail: {
        locations: {
            header: '地点',
            viewAll: '查看全部',
            noLocations: '无地点',
            allLocations: '全部地点',
        },
        jobModule: {
            header: '热门职位',
            viewAllJobs: '查看{companyName}的所有职位',
            noPositions: '{companyName}目前暂无职位',
            defaultLabel: '开放职位',
        },
        videos: {
            header: '视频',
            noVideos: '无视频',
            noMoreVideos: '无更多视频',
            moreVideosFrom: '更多{companyName}的视频',
        },
        articles: {
            header: '资讯',
            noArticles: '无资讯',
            noMoreArticles: '无更多资讯',
            moreArticlesFrom: '更多companyName}的资讯',
        },
    },
    components: {
        builders: {
            searchable: { create: '创建' },
            yearMonthPicker: { defaultSelect: '选择月份' },
            localeDropdown: { languages: { en: '英文', cn: '中文' } },
        },
        miscellaneous: {
            verifyModule: {
                title: '验证您的学校邮箱',
                description: '快速验证，马上解锁独家内推职位、在线测评及海量求职资源',
                verificationPending: '验证中',
                weHaveSentAnEmail:
                    '我们已经将邮件发送至<strong>{studentEmail}</strong>供您验证院校身份。若未收到邮件，请检查您的垃圾箱。',
                verifyMe: '开始身份验证',
                resendVerifyEmail: '再次发送验证邮件',
                cancelVerification: '取消验证',
                emailSent: '邮件已发送',
                emailSentMessage: '邮件已成功发送，如果您未收到邮件，请联系support@highered.global',
                resendErrorTitle: '重新发送邮件失败',
                resendErrorMessage: '无法重新发送验证邮件，请联系support@highered.global',
                verificationCancelledTitle: '验证取消',
                verificationCancelledMessage: '验证取消成功',
                cancelErrorTitle: '取消错误',
                cancelErrorMessage: '无法取消验证，请联系support@highered.global',
            },
            verifyModuleDialog: {
                title: '验证您的学校邮箱',
                university: '院校',
                studentEmail: '您的学校邮箱地址',
                studentEmailPlaceholder: '校园邮箱',
                verify: '验证',
                verificationInProcess: '验证中',
                emailHasBeenSentTo:
                    '邮件已发送至<strong>{email}</strong>。请按照邮件中的指引完成学生身份验证。',
                ifNoEmailRecieved: '如果您未收到验证邮件，请联系我们。',
                contactHelp: '联系我们',
            },
        },
        navigation: {
            navigation: {
                myPage: '我的主页',
                myProfile: '我的简历',
                jobs: '职位',
                companies: '公司',
                resources: '优职讲堂',
                assessments: '在线测试',
                countryGuides: '国家指南',
                goToHaigui: '在中国的职位',
                vfairs: '全球精英线上招聘会',
                signIn: '登录',
            },
            profileNavigation: { signOut: '退出' },
            sidebar: {
                myPage: '我的主页',
                findJobs: '搜索职位',
                findCompanies: '搜索公司',
                resources: '优职讲堂',
                countryGuides: '国家指南',
                assessments: '在线测试',
                goToHaigui: '在中国的职位',
                virtualFairs: '全球精英线上招聘会',
                signIn: '登录',
                logOut: '退出',
            },
        },
        smart: {
            companyModule: {
                followJob: '收藏职位',
                followCompany: '关注公司',
                unFollowJob: '移出收藏',
                unFollowCompany: '取消关注',
                favoritedTitle: '已收藏',
                favoritedMessage: '您已收藏该职位，您可在“我的主页”查看。',
                unfavoritedTitle: '已移出收藏',
                unfavoritedMessage: '该职位已被移出收藏',
                favoriteErrorTitle: '出现错误',
                favoriteErrorMessage: '无法收藏职位',
            },
            profileModule: {
                profileCompletion: '完善简历',
                profileCompletionEncouragement:
                    '简历还剩 {percentageLeft}未填写，完善简历，获得更多HR关注及招聘机会',
                gotoProfilePage: '更新简历',
                profileCompleted: '完成简历',
                profileCompletedWhatsNext:
                    '你知道吗？目前HR广泛运用测评进行人才筛选。马上开始测评实战演练吧！',
                gotoTestsPage: '进入测评',
                authIndication: {
                    title: '搜索职位',
                    description:
                        '想要获得独家求职资源及职位信息？现在就注册吧。Google, LinkedIn或Facebook账号均可使用。',
                    action: '开始',
                },
                toProfileHint: '转到我的简历',
                profileActions: {
                    addFirstName: '添加名',
                    addLastName: '添加姓',
                    addNationality: '添加国籍',
                    addPhoneNumber: '添加电话号码',
                    addLanguage: '添加语言',
                    addEducation: '添加一项教育背景',
                },
            },
            featuredCompanies: { label: '重点推荐公司' },
            featuredPositions: { label: '重点推荐职位' },
            featuredResource: {
                header: '全球精英线上招聘会',
                cta: '立即参加!',
                wechatSignupHeader: '加入Highered微信群，及时了解各种职位活动更新~',
                wechatSignupCta: '扫码马上进群！',
            },
        },
    },
    cts: {
        filterNames: {
            employment_types: '工作类型',
            education_level: '学历要求',
            job_category: '科系类别',
            address: '地点',
            sector: '行业',
            exclude_school_id: '排除学校',
        },
        excludeSchoolIds: {
            '-1': '转发消息',
            unknownSchoolId: 'EFMD院校合作伙伴',
        },
        educationLevels: {
            BACHELORS_OR_EQUIVALENT: '本科',
            MASTERS_OR_EQUIVALENT: '硕士',
            DOCTORAL_OR_EQUIVALENT: '博士',
            MBA_OR_EQUIVALENT: 'MBA',
            DBA_OR_EQUIVALENT: 'DBA',
        },
        employmentTypes: {
            FULL_TIME: '全职',
            INTERN: '实习',
            TEMPORARY: '兼职',
            PART_TIME: '兼职',
        },
        startDate: '入职日期',
        educationFields: {
            ACCOUNTING_AND_FINANCE: '会计和金融',
            ADMINISTRATIVE_AND_OFFICE: '行政和办公',
            ADVERTISING_AND_MARKETING: '广告和营销',
            ART_FASHION_AND_DESIGN: '艺术时尚与设计',
            BUSINESS_OPERATIONS: '商业运营',
            COMPUTER_AND_IT: '电脑和信息技术',
            CUSTOMER_SERVICE: '客户服务',
            EDUCATION: '教育',
            HEALTHCARE: '卫生保健',
            HUMAN_RESOURCES: '人力资源',
            INSTALLATION_MAINTENANCE_AND_REPAIR: '安装维护和修复',
            LEGAL: '法律',
            MANAGEMENT: '管理',
            MANUFACTURING_AND_WAREHOUSE: '制造和仓库',
            MEDIA_COMMUNICATIONS_AND_WRITING: '媒体传播和写作',
            OIL_GAS_AND_MINING: '能源',
            PROTECTIVE_SERVICES: '安保防护',
            REAL_ESTATE: '房地产',
            SALES_AND_RETAIL: '销售和零售',
            SCIENCE_AND_ENGINEERING: '科学与工程',
            SOCIAL_SERVICES_AND_NON_PROFIT: '社会服务和非营利',
            TRANSPORTATION_AND_LOGISTICS: '运输和物流',
        },
        sectors: {
            Consulting: '咨询',
            'Consumer Goods': '消费品',
            'Financial Services / Banking': '金融服务/银行业',
            'Goverment / Public Administration / Non Profit': '政府/公共行政/非营利组织',
            'International Trade & Development': '国际贸易与发展',
            Manufacturing: '制造业',
            'Media / Entertainment': '媒体/娱乐',
            'Petroleum / Energy': '石油/能源',
            'Pharma / Healthcare / Biotech': '制药/保健/生物技术',
            'Real Estate / Construction / Infrastructure': '房地产/建筑/基础设施',
            'Technology (IT) / Telecom': '科技（IT）/电信',
            'Transportations & Logistics': '运输与物流',
            Other: '其他',
        },
        countries: {
            Norway: '挪威',
            Spain: '西班牙',
            China: '中国',
            Netherlands: '荷兰',
            Morocco: '摩洛哥',
            Argentina: '阿根廷',
            Belgium: '比利时',
            France: '法国',
            Switzerland: '瑞士',
            'United Kingdom': '英国',
            Germany: '德国',
            Luxembourg: '卢森堡',
            'United Arab Emirates': '阿联酋',
            Ukraina: '乌克兰',
            Italy: '意大利',
            Brazil: '巴西',
            USA: '美国',
            Russia: '俄罗斯',
            Swaziland: '斯威士兰',
            India: '印度',
            Australia: '澳大利亚',
            Afghanistan: '阿富汗',
            Austria: '奥地利',
            Philippines: '菲律宾',
            Poland: '波兰',
            Singapore: '新加坡',
            Sweden: '瑞典',
            'China (Hong Kong SAR)': '香港',
            Denmark: '丹麦',
            Portugal: '葡萄牙',
            Indonesia: '印度尼西亚',
            Malaysia: '马来西亚',
            'Korea, South': '韩国',
            Mexico: '墨西哥',
            Qatar: '卡塔尔',
            'Costa Rica': '哥斯达黎加',
            Finland: '芬兰',
            Canada: '加拿大',
            Lithuania: '立陶宛',
            Kuwait: '科威特',
            Hungary: '匈牙利',
            Ireland: '爱尔兰',
            Thailand: '泰国',
            'Taiwan (Province of China)': '台灣',
            Kazakhstan: '哈萨克斯坦',
            'New Zealand': '新西兰',
            Czechia: '捷克',
            Egypt: '埃及',
            Turkey: '土耳其',
            'South Africa': '南非',
            Slovakia: '斯洛伐克',
            Paraguay: '巴拉圭',
            Kenya: '肯尼亚',
            Zambia: '赞比亚',
            Botswana: '博茨瓦纳',
            Etiopia: '埃塞俄比亚',
            Tanzania: '坦桑尼亚',
            Japan: '日本',
            Romania: '罗马尼亚',
            Greece: '希腊',
            Senegal: '塞内加尔',
            Israel: '以色列',
            Mauritius: '毛里求斯',
            'Saudi Arabia': '沙特阿拉伯',
            'Europe & Sub-Saharan Africa': '欧洲 & 撒哈拉以南非洲地区',
            Pakistan: '巴基斯坦',
            Armenia: '亚美尼亚',
            Bulgaria: '保加利亚',
            Bangladesh: '孟加拉国',
            Jersey: '泽西岛',
            Estonia: '爱沙尼亚',
            Lebanon: '黎巴嫩',
            Latvia: '拉脱维亚',
            Colombia: '哥伦比亚',
            Algeria: '阿尔及利亚',
            Jordan: '约旦',
            Serbia: '塞尔维亚',
            Myanmar: '缅甸',
            Vietnam: '越南',
            "Côte d'Ivore (Ivory Coast)": '科特迪瓦',
            'Puerto Rico': '波多黎各',
            Namibia: '纳米比亚',
            Oman: '阿曼',
            Iraq: '伊拉克',
            Chile: '智利',
            Croatia: '克罗地亚',
            Nigeria: '尼日利亚',
            Slovenia: '斯洛文尼亚',
            Iceland: '冰岛',
            Syria: '叙利亚',
            Vanuatu: '瓦努阿图',
            Mongolia: '蒙古',
            Peru: '秘鲁',
            Angola: '安哥拉',
            Belarus: '白俄罗斯',
            Tonga: '汤加',
            Azerbaijan: '阿塞拜疆',
            Bahamas: '巴哈马',
            'Papua-Ny Guinea': '巴布亚新几内亚',
            Uzbekistan: '乌兹别克斯坦',
            Fiji: '斐济',
            Congo: '刚果',
            Sudan: '苏丹',
            Ghana: '加纳',
            Ecuador: '厄瓜多尔',
            Cambodia: '柬埔寨',
            'The Seychell Islands': '塞舌尔',
            'Sri Lanka': '斯里兰卡',
            Bahrain: '巴林',
            Laos: '老挝',
            Guernsey: '根西岛',
            Cyprus: '塞浦路斯',
        },
    },
    emailverification: {
        headerLabel: '邮箱验证',
        verifyingEmail: '正在验证邮箱',
        emailVerifySuccess: '邮箱验证成功！',
        emailVerifyFailure: '遇到故障...请稍后再试或联系技术支持部门',
        gotoMyPage: '回到我的主页',
    },
    errors: {
        defaultErrorMessage: '发生错误！',
        logInErrorText: {
            invalidCredentials: '用户名或密码错误',
            inactiveUser: '无法找到使用该邮箱注册的用户，请检查邮件激活帐户或尝试重置密码',
            default: '无法进行身份验证',
        },
        registerErrorText: {
            passwordTooShort: '密码必须至少为8位数',
            emailTaken:
                '该邮箱已被注册。这可能是因为您已使用该邮箱在旧平台(higheredtalent.org)上注册信息，请联系技术支持。',
            default: '无法创建用户',
        },
        invalidTokenText: { default: '动态码已失效或过期' },
        passwordErrorText: {
            passwordTooShort: '密码必须至少为8位数',
            requireNonAlphanumeric: '密码必须至少包含一个特殊字符',
            requireLowerCase: '密码必须至少包含一个小写字母',
            requireUpperCase: '密码必须至少包含一个大写字母',
            requireUniqueChars: '密码必须至少包含6个不同的字符',
            default: '无法更改密码',
        },
        recoverErrorText: {
            userNotFound: '用户不存在！请联系技术支持部门',
            userAlreadyActive: '用户已激活！请尝试登录',
            emailAlreadyInUse: '该邮件地址已被使用。请尝试使用其他电子邮件或社交账号登录。',
            default: '无法激活帐户。请稍后再试。',
        },
        socialAuthErrorText: {
            errorTitle: '无法使用{provider}登录',
            invalidProviderGoogle:
                '该邮箱未关联Google。请尝试使用LinkedIn，Facebook或电子邮箱登录。',
            invalidProviderFacebook:
                '该邮箱未关联Facebook。请尝试使用Google，LinkedIn或电子邮件登录。',
            invalidProviderLinkedIn:
                '该邮箱未关联LinkedIn。请尝试使用Google，Facebook或电子邮件登录。',
            invalidProviderWeChat:
                '该邮箱未关联微信。请尝试使用Google，Facebook，LinkedIn或电子邮件登录。',
        },
        uniConnErrorText: {
            emailNotAvailable:
                '该邮箱已被注册。这可能是因为您已使用该邮箱在旧平台(higheredtalent.org)上注册信息，请联系技术支持。',
            invalidEmailDomain: '该邮箱域名与所选大学不匹配。请选择正确的大学。',
            existingConnection: '该用户已与所选大学匹配成功',
            default: '无法启动验证',
        },
        spotlightErrors: {
            userUpdate: {
                emailAlreadyInUse: '该邮箱已被注册',
                default: '无法更新用户数据',
            },
        },
    },
    favorites: {
        header: '我的收藏',
        active: '开放申请',
        expired: '职位已截止申请',
        expiresThisMonth: '本月申请截止',
        expiresThisWeek: '本周申请截止',
        expiresLater: '正在申请中',
        noActiveFavorites: '无可申请职位',
        noExpired: '无已过期职位',
    },
    findcompanies: { headerLabel: '搜索公司', companyListLabel: '公司' },
    findjobs: {
        header: '搜索职位',
        changeFilters: '更改筛选项',
        recruitmentModule: {
            body: '请问您是招聘官，人才领域从业者还是对招聘在校生/毕业生有兴趣？',
            createJob: '点击这里创建职位',
        },
    },
    general: {
        documentTitle: '全球机遇平台',
        email: '电子邮件',
        password: '密码',
        confirmPassword: '确认密码',
        loading: '载入中',
        ok: '确定',
        save: '保存',
        add: '添加',
        close: '关闭',
        delete: '删除',
        done: '完成',
        back: '上一步',
        next: '下一步',
        finish: '完成',
        success: '成功',
        error: '错误',
        months: [
            '一月',
            '二月',
            '三月',
            '四月',
            '五月',
            '六月',
            '七月',
            '八月',
            '九月',
            '十月',
            '十一月',
            '十二月',
        ],
        days: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
        dialogs: {
            helperTexts: {
                checkHasPendingAction: '正在进行身份验证',
                verifySchoolConnection: '验证您所属院校关系后即可解锁更多求职资源',
                logInToAccessMoreFeatures: '登录后即可解锁更多功能',
            },
        },
    },
    jobdetail: {
        detailModule: {
            deadline: '申请截止时间',
            location: '地点',
            employmentType: '工作类型',
            languageRequirements: '语言要求',
            workPermitRequirements: '工作许可要求',
            preferredEducationField: '首选专业',
            preferredEducationLevel: '首选学历',
            jobTags: '标签',
            apply: '现在申请',
            verificationRequired: '验证学校邮箱后即可申请',
            verificationRequiredHint: '验证学校邮箱后即可申请',
            verificationPending: '这所学校等待您进行身份验证',
            verificationPendingHint: '这所学校等待您进行身份验证',
        },
    },
    mypage: {
        header: '我的主页',
        suggestedPositions: '推荐职位',
        favoriteModule: {
            header: '已收藏职位',
            seeAll: '查看全部',
            noFavorites: '无收藏职位',
        },
    },
    recoverpassword: {
        createPassword: '创建新密码',
        newPasswordLabel: '新密码',
        newPasswordPlaceholder: '密码',
        confirmPasswordLabel: '确认密码',
        confirmPasswordPlaceholder: '确认密码',
        resetPasswordButton: '密码重置',
        resettingPassword: '密码正在重置',
        passwordsNotMatching: '密码不匹配',
    },
    recoveruser: {
        headerLabel: '恢复Highered用户',
        accountActivation: '帐户激活',
        step1: {
            header: '欢迎登陆新平台',
            subHeader: '选择关联您的帐户的方式',
            description: '下次快速登录？绑定以下至少一项即可',
            OR: '或',
            emailAndPassword: '使用您的个人邮箱',
        },
        step2: {
            header: '使用电子邮箱和密码',
            description:
                '此邮箱将作为您帐户的主邮箱。我们建议您使用非学校邮箱，以便在毕业后继续访问个人数据。此后您可以在帐户设置中更改邮件接受偏好。',
            invalidEmail: '该邮箱地址为无效地址',
            passwordsNotMatch: '密码不匹配',
            passwordDescription01: '为确保您的帐户安全，请设置新密码。请注意：',
            passwordDescription02: '至少8个字符',
            passwordDescription03: '至少一个小写字符（a-z）',
            passwordDescription04: '至少一个大写字符（A-Z）',
            passwordDescription05: '至少一个数字或特殊符号（0-9，！＃$％等）',
            passwordDescription06: '至少包含6个不同的字符',
            repeatPassword: '重置密码',
        },
        step3: {
            header: '激活用户',
            loadingHints: ['加载用户数据', '即将准备就绪', '发现更多机会', '即将完成'],
            successHeader: '您的帐户现已准备就绪！',
            successSubheader: '已解锁最新独家功能',
            errorHeader: '无法激活帐户',
            ifWrongContact: '如果您认为此处有误，请联系支持部门',
            contactForHelp: '联系以获取帮助',
            goBack: '上一步',
        },
    },
    resourcesInternal: {
        header: '优职讲堂',
        //TODO resourceTypeHeader: '',
        //TODO resourceTitleHeader: '',
        //TODO resourcePublishDateHeader: '',
        //TODO resourceDownloadHeader: '',
        //TODO searchPlaceholder: '',
    },
    shared: {
        userNavSection: {
            myPage: '我的主页',
            myProfile: '我的简历',
            myTests: '在线测试',
            myApplications: '应用',
            myFavorites: '收藏夹',
        },
        searchModule: {
            searchBar: { label: '按标题或关键字搜索' },
            filters: { clearFilters: '重置筛选项' },
        },
        postingModule: {
            postingModule: {
                positions: '职位',
                estimatedCount: 'ca {count}的{totalCount}',
                knownCount: '{count}的{totalCount}',
                noMatchFound: '无法找到符合您条件的任何内容',
            },
            postItem: { applyBefore: '在此日期前申请' },
            postCard: { deadline: '截止日期' },
        },
        loginModule: {
            emailVerificationTip: '邮件可能需要几分钟才能到达您的收件箱',
            noEmail: '没有邮件？请检查您的邮箱垃圾箱或：',
            logIn: '登录',
            socialAuthBtns: {
                continueWithFacebook: '使用Facebook继续',
                continueWithGoogle: '使用Google继续',
                continueWithLinkedIn: '使用LinkedIn继续',
                continueWithWeChat: '使用微信继续',
            },
            verifyEmail: {
                verifyYourEmail: '请验证您的电子邮件',
                weSentAnEmailTo: '验证信息已发送',
                continueToSignIn: '继续登录',
                resendEmail: '重新发送验证链接',
                newEmailSent: '新邮件已发送',
            },
            registerForm: {
                recommendation:
                    '为确保您在毕业后仍可访问您的数据，我们建议您使用您的个人电子邮箱而非学校的电子邮箱登录',
                register: '登记信息',
                passwordsNotMatch: '密码不匹配',
            },
            logInPaper: {
                useEmail: '或使用您的电子邮件',
                noAccount: '没有帐户？',
                signUp: '注册新账号',
                logInToAccess: '登录即可访问此功能',
            },
            logInForm: { logIn: '登录', forgotPassword: '忘记密码？' },
            forgotPassword: {
                title: '请求密码重置',
                description: '不用担心 - 谁又能总是记住密码呢？请输入邮箱地址以重置密码',
                resetPassword: '密码重置',
                emailSentTitle: '技术支持正在全速赶来！',
                emailHasBeenSent:
                    '已向<strong>{email} </ strong> <br>发送了一封电子邮件，其中包含有关如何重置密码的说明。请检查您的收件箱。',
                noEmail: '没有收到邮件？',
                sendEmailOneMoreTime: '再次发送邮件',
                resendErrorTitle: '恢复密码时出错',
                resendErrorMessage: '无法发送重置密码的邮件。请核实邮箱地址。',
            },
        },
        universityBadges: {
            addAnotherUniversity: '添加一所大学',
            verificationDialog: {
                verifiedStudent: '已验证{schoolAbbr}学生',
                verificationDescription: '您已验证为{schoolAbbr}的学生，邮箱地址为{email}',
                checkYourEmail: '查看您的{schoolAbbr}电子邮箱',
                sentEmailDescription:
                    '我们向{emailAbbr}发送了一封关于{schoolAbbr}验证的电子邮件。请检查您的收件箱。',
                resendEmail: '邮件重发',
                cancelVerification: '取消验证',
                notYetVerified: '大学隶属关系尚未经过验证。',
                verifyYourAffiliation:
                    '要访问{schoolAbbr}特定功能，如独家职位发布和资源，请验证您的yuanx从属关系。',
                verify: '验证',
            },
        },
        universityAvatar: {
            dialogs: {
                verificationDialog: {
                    verifiedStudent: '已验证{uniSubDomain}学生',
                    verifiedStudentWithEmail:
                        '您是经过验证的{uniSubDomain}学生，其电子邮件为{email}',
                    checkEmail: '查看您的{uniSubDomain}电子邮件。',
                    sentEmailInfo:
                        '我们向{email}发送了一封关于{uniSubDomain}验证的电子邮件。请检查您的电子邮件。',
                    resendEmail: '重发电子邮件',
                    cancelVerification: '取消验证',
                    notYetVerified: '大学隶属关系尚未经过验证。',
                    resourceAccessInfo:
                        '要访问{uniSubDomain}特定功能，如独家职位发布和资源，请验证您的从属关系。',
                    verificationCancelled: '验证已取消',
                    emailSent: '邮件已发送',
                },
            },
        },
        termsAndConds: {
            termsAndConditions: '使用条款',
            privacyPolicy: '隐私政策',
            talentPanel: 'Talent Panel',
        },
    },
    spotlight: {
        header: '我的简历',
        saveChangesToSubmit: '保存简历以使更改生效',
        saveChanges: '保存更改',
        saveSuccessful: '您的更改已成功',
        personalDetails: {
            header: '个人资料',
            firstName: '名',
            lastName: '姓',
            nationality: '国籍',
            uploadProfileImage: '上传照片',
            wrongFileTypeErrorHeader: '文件格式不支持',
            wrongFileTypeErrorDescription: '仅可上传图片',
        },
        contactDetails: {
            header: '联系方式',
            contactEmail: '联系电子邮件',
            phoneNumberHeader: '手机号码',
            countryCode: '国家代码',
            phoneNumber: '电话号码',
            invalidEmail: '输入邮箱无效',
        },
        languages: {
            header: '语言',
            languageLabel: '语言',
            levelLabel: '语言水平',
            addLanguage: '添加新语言',
            proficiencies: {
                '22f882cc-3cb0-4cfd-a590-ef010f4d798b': '基础',
                '82edcac6-693b-42ea-bf24-0a52774f395c': '一般，能进行基本工作沟通',
                'a97f6798-7280-4ce7-8896-6d4a8fb58c63': '流畅，可作为工作语言',
                '93b37709-3f2d-4853-ac77-b8c0dd07243e': '精通，所有工作场景均可应用',
                '250d296e-d6db-46fb-8c44-07950db80ec4': '母语或母语之一',
            },
        },
        education: {
            header: '教育背景',
            addEducation: '添加教育',
            notGraduated: '尚未毕业',
            graduatedIn: '毕业于{date}',
            dialog: {
                addNewEducation: '增加新的教育',
                degreeTitle: '专业',
                institution: '院校',
                degreeType: '学位',
                fieldOfStudy: '所学专业',
                studyStart: '入学月份',
                studyEnd: '毕业月份',
                invalidDegreeTitle: '您需要填写学位名称',
                invalidSchool: '您需要选择一所学校',
                invalidStartDate: '请选择入学日期',
                invalidEndDate: '请选择毕业日期',
                invalidStudyPeriod: '入学日期必须在毕业日期之前',
                invalidDegreeField: '请选择您的专业',
                invalidDegreeLevel: '请选择您的受教育程度',
                selectStartDate: '入学日期',
                selectEndDate: '毕业日期',
                degrees: {
                    '5b468395-7bf7-4f14-88d9-32096884d4ef': '本科',
                    '09f419fa-1517-41ce-970c-df0d073fc440': '研究生',
                    '2c917ed6-5bb7-4e23-95ab-60c55d8df135': 'MBA',
                    '1fff1451-f07c-415c-954a-63b1e5f44fc8': 'DBA',
                    '2fbd6155-d939-40cc-970d-283be0aef433': '博士生',
                },
                diciplins: {
                    '383c2086-24da-4fe2-977b-7e3d4da85f8e': '农林业',
                    'c8fb1348-bdac-4ed3-af7a-a831376d04b7': '应用科学专业',
                    '5c665d94-5124-4226-a4f6-da8cca47e3f6': '艺术，设计和建筑',
                    '06b028e2-d7ed-4281-8668-1009d6da1c35': '商业管理',
                    '747624bb-0174-4961-a3c0-dbe4f1cb750d': '计算机科学&IT',
                    'ede2bbdb-7a1d-466c-99e5-bcab52e07d69': '经济学',
                    '5c0432d4-9297-429a-85c4-3305d207764e': '教育&培训',
                    '8198b6ea-5b28-4be2-afbc-45df759c65cb': '工程&技术',
                    '7e5c0527-d1ec-4125-945e-138ec473e8dd': '环境研究&地球科学',
                    '3babe28b-6285-4a03-b0b8-43f55be393cd': '酒店、休闲&运动',
                    '9eebcc51-385e-4122-88a1-6dd3efbaf896': '人文学',
                    '390cf111-b55a-4bb7-a6b6-1cc2b21a248f': '新闻&媒体',
                    'a2744908-9521-4330-a07d-3680b058d0a6': '法律',
                    '947993e1-b723-4d85-8cd9-a4ae46cd623e': '市场营销',
                    'c98802c8-74a5-4a98-99ba-84eb76fd1a60': '创新与商业硕士',
                    'bca263cc-3d17-4ad8-b70e-e2bfe04421fa': '发展管理学硕士',
                    'a37667e2-5713-4157-82e9-78c10760d2de': '数据科学硕士',
                    '72277bb7-9d5e-422a-a2b4-8a8fb8be7143': '医药&健康',
                    'bd84a8cd-ce66-4c61-86a8-7fcb6644cc5d': '金融学硕士',
                    '9e665ac9-9611-4508-af4b-22e91f167ea4': '国际商务硕士',
                    'baf5bb0a-d0ab-4c13-aacc-c6a8a90e2fcf': '商业分析硕士',
                    '7d832109-642a-4730-aada-26927eb683ee': '管理学硕士',
                    'baf05a5a-faba-4f30-9254-9cd73bb63bbf': '自然科学&数学',
                    '828cc4ac-1f2b-4133-8e29-ba1347585ae6': '社会科学',
                    '44c1f8cf-8696-4638-bc03-9763c2de32af': '其他',
                },
            },
        },
        communication: {
            header: '邮件沟通',
            sendMeUpdatesDescription: '同意邮件接收职位信息、求职资讯及公司信息',
        },
        errors: {
            imageUpload: { title: '图片无法上传', message: '图片尺寸过大' },
        },
        exitDialog: {
            title: '未保存修改将丢失',
            message: '您的修改并未保存，是否需要保存后再离开？',
            stayAction: '停留在此页面',
            saveAction: '保存简历',
            continueAction: '不保存，继续编辑',
        },
    },
    tests: {
        header: '在线测试',
        unauthorized: '在线测试即将上线，敬请期待！',
        assessmentModule: { header: '您的测评' },
        tests: {
            comingSoon: '即将上线！',
            cute: {
                title: 'Cut-e 职场测评',
                description:
                    '了解您工作相关的行为，数字推理，口头推理和职业兴趣，并获得全面的反馈报告。 Cut-e被视为招聘过程中毕业生评估的黄金标准。',
                action: '开始测试',
            },
            programming: { title: '加载测试中' },
        },
        cute: {
            header: 'Cut-e 职场测评',
            title: '开始您的Cut-e测评',
            description:
                '您即将开始的测评由Cut-e AS提供，Cut-e AS对您在测评中提供的个人信息负主要责任。在未获得您许可的情况下，您的数据将不会透露给任何第三方。',
            consent:
                '我理解Cut-e对我在测评中提供的数据负责并同意其服务条款。我同意Highered将我的姓名提供给Cut-e来生成我的报告。',
            openTest: '开始测评',
            consentErrorTitle: '无法提交同意',
            consentErrorMessage: '提交同意错误，请联系技术支持',
            completed: '已完成',
            inProgress: '进行中',
            notStarted: '未开始',
            blocked: '无法加载',
            completeAllTestsTitle: '完成测试后即可查看您的测试结果',
            testsCompletedTitle: '成功完成测试！查看您的测试结果！',
            testCompletedCount: '{count}/{totalCount} 已完成',
            seeScore: '查看测试结果',
            tests: {
                '102': '职业行为测试',
                '311': '数字推理测试',
                '312': '语言逻辑测试',
                '606': '职业兴趣及动机测试',
                unknown: '无法获取信息',
            },
        },
    },
};
